//相当于导包(系统包)
import Vue from 'vue';
import router from 'vue-router'; /* 导入路由*/

//相当于导入自己的package
import Index from "../views/app/index.vue"
import about from "../views/app/page/about.vue"
import contact from "../views/app/page/contact-us.vue"
import faq from "../views/app/page/faq.vue"
import customerCases from "../views/app/page/customerCases.vue"
import customerCaseDetail from "../views/app/page/customerCaseDetail.vue"
import news from "../views/app/page/news.vue"
import newsDetails from "../views/app/page/news-details.vue"
import NotFound from "../views/app/page/404.vue"
import NewsManage from "../views/app/back/NewsManage.vue"
import newsList from "../views/app/back/newsList.vue"
import Login from "../views/app/back/Login.vue";
import BackStage from "../views/app/back/Main.vue";
import AdminList from "../views/app/back/AdminList.vue";
import AboutUsManage from "../views/app/back/AboutUsManage.vue";
import FAQManage from "../views/app/back/FAQManage.vue";
import PartnerManage from "../views/app/back/PartnerManage.vue";
import MessageManage from "@/views/app/back/MessageManage.vue";
import LogRecordManage from "@/views/app/back/LogRecordManage.vue";
import RoleManage from "@/views/app/back/RoleManage.vue";
import Home from "../views/app/back/Home.vue";


//类似于数据库中的use school_db
Vue.use(router);

/* 定义组件路由 */
//也就是给自己写的东西赋一个地址
var rout = new router({
    mode: 'history',  // 使用 history 模式
    // 每次路由切换时滚动到页面顶部
    scrollBehavior(to, from, savedPosition) {
        // 始终滚动到顶部
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: '/',
            component: Index,
            name: 'index',
            meta: {title: '西安伟思特声学科技有限公司'}
        },
        {
            path: '/index',
            component: Index,
            name: 'index',
            meta: {title: '首页_西安伟思特声学科技有限公司'}
        },
        {
            path: '/about',
            component: about,
            meta: {title: '关于我们_西安伟思特声学科技有限公司'}
        },
        {
            path: '/contact',
            component: contact,
            meta: {title: '联系我们_西安伟思特声学科技有限公司'}
        },
        {
            path: '/faq',
            component: faq,
            meta: {title: '常见问题_西安伟思特声学科技有限公司'}
        },
        {
            path: '/news',
            component: news,
            meta: {title: '新闻资讯_西安伟思特声学科技有限公司'}
        },
        {
            path: '/customerCases',
            component: customerCases,
            meta: {title: '客户案例_西安伟思特声学科技有限公司'}
        },
        {
            path: '/customerCaseDetail',
            component: customerCaseDetail,
            meta: {title: '客户案例详情_西安伟思特声学科技有限公司'}
        },
        {
            path: '/newsDetails',
            component: newsDetails,
            meta: {title: '新闻详情_西安伟思特声学科技有限公司'}
        },
        {
            path: '/WesteSound-login',
            component: Login,
            meta: {title: '后台登录_西安伟思特声学科技有限公司'}
        },
        {
            path: '/main',
            component: BackStage,
            children: [
                {
                    path: "/adminManage",
                    component: AdminList,
                    meta: {title: '管理员管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: "/aboutusManage",
                    component: AboutUsManage,
                    meta: {title: '关于我们管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: "/faqManage",
                    component: FAQManage,
                    meta: {title: '常见问题管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: "/partnerManage",
                    component: PartnerManage,
                    meta: {title: '合作伙伴管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: '/logRecordManage',
                    component: LogRecordManage,
                    meta: {title: '日志查询_西安伟思特声学科技有限公司'}
                },
                {
                    path: '/roleManage',
                    component: RoleManage,
                    meta: {title: '权限管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: "/messageManage",
                    component: MessageManage,
                    meta: {title: '留言管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: "/home",
                    component: Home,
                    meta: {title: '后台首页_西安伟思特声学科技有限公司'}
                },
                {
                    path: '/newsManage',
                    component: NewsManage,
                    meta: {title: '新闻管理_西安伟思特声学科技有限公司'}
                },
                {
                    path: '/newsList',
                    component: newsList,
                },
            ]
        },
        {
            path: '*',
            component: NotFound,
            meta: {title: '404 - 页面未找到_西安伟思特声学科技有限公司'}
        },
    ]
});


//导出路由对象
export default rout;
//就是上面写的那个,赋地址的函数(var rout = new router)
//将其导出来,放到main.js中


// 路由导航守卫,每一次发生跳转时,都会执行此段代码
// rout   跟上面的名字保持一致
// to:你要去哪  from:你从哪里来的  next:允许通行
rout.beforeEach((to, from, next) => {
    // 如果是404页面，直接允许访问
    if (to.matched.length === 0 || to.matched.some(record => record.path === '*')) {
        return next();
    }
    if (to.path == '/WesteSound-login' || to.path == '/' || to.path == '/contact'
        || to.path == '/customerCases' || to.path == '/customerCaseDetail' || to.path == '/newsDetails' ||
        to.path == '/news' || to.path == '/about' || to.path == '/faq' ||
        to.path == '/baidu_verify_codeva-MZODRgP9ve.html') {
        return next();
    } else {
        const account = sessionStorage.getItem("account");
        if (account == null || account === "") {
            return next("/");
        } else {
            next();
        }
    }
})

rout.beforeEach((to, from, next) => {
    // 设置标题
    document.title = to.meta.title || '西安伟思特声学科技有限公司';
    next();
});
